import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Virtual } from "swiper/modules";
import "swiper/css";

import SignUpForm from "@/components/form/signup";
import Game from "@/components/game";
import { Button } from "@/components/ui/button";
import { useAppStore } from "@/store/app";
import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaTimesCircle } from "react-icons/fa";

import logo from "@/assets/img/logo.svg";
import banner from "@/assets/img/header-banner.svg";
import bgFooter from "@/assets/img/footer-decoration.svg";
import bgScroller from "@/assets/img/bg-flower.svg";
import gamificaBB from "@/assets/img/logo-gamificabb-footer.svg";

import iconFooterAdesivo from "@/assets/img/footer-adesivo.svg";
import iconFooterBB from "@/assets/img/footer-bb.svg";
import iconFooterGames from "@/assets/img/footer-games.svg";
import iconFooterAssinatura from "@/assets/img/footer-assinatura.svg";
import AccessDenied from "@/components/access-denied";

const TOTAL_PICTURES = 16;

export default function LandingPage() {
  const { user, validateAccess, logout } = useAppStore();

  const [accessDenied, setAccessDenied] = useState(false);
  const [displayGame, setDisplayGame] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleOpenGame = useCallback(() => {
    setDisplayGame(true);
  }, []);

  const handleQuitGame = useCallback(() => {
    setDisplayGame(false);
    setAccessDenied(false);
    logout();
  }, [logout]);

  const checkAccess = useCallback(async () => {
    const hasAccess = await validateAccess();
    setAccessDenied(!hasAccess);
    setLoading(false);
  }, [user, validateAccess]);

  useEffect(() => {
    if (user) {
      checkAccess();
    }
  }, [user]);

  return (
    <>
      {displayGame ? (
        <FaTimesCircle
          size={40}
          className="absolute z-40 top-5 right-5 text-black opacity-50 w-[40px] h-[40px] closeItem"
          onClick={() => handleQuitGame()}
        />
      ) : null}
      {displayGame &&
        createPortal(
          <div className="relative top-0 left-0 w-full h-full z-20 bg-opacity-80 flex items-center justify-center">
            <div className="w-full h-full relative bg-white">
              {!loading && !accessDenied && user ? (
                <Game onQuit={handleQuitGame} />
              ) : accessDenied ? (
                <AccessDenied />
              ) : (
                <SignUpForm />
              )}
            </div>
          </div>,
          document.body,
        )}

      {!displayGame && (
      <div>
        <div
          className="flex w-full h-[600px] relative bg-no-repeat bg-cover bg-right"
          style={{
            backgroundImage: `url(${banner})`,
            backgroundSize: "100% 100%"
          }}
        >
          <div className="flex flex-col items-start justify-around p-20">
            <img src={logo} alt="logo" className="w-auto h-20 mb-4" />

            <div className="flex flex-col gap-5">
              <h1 className="text-2xl font-bold">
                Seja bem-vinda ao{" "}
                <span className="text-primary">seu espaço</span>!
              </h1>
              <p className="text-lg">
                Conheça as mulheres que mudaram
                <br />a tecnologia!
              </p>
            </div>
          </div>
        </div>
        <div className="bg-secondary gap-5 flex flex-col items-center justify-center p-10 text-center">
          <h3 className="text-4xl font-bold">Quiz sobre Mulheres na TI</h3>
          <p>
            Participe do nosso quiz, teste seus
            <br />
            conhecimentos e celebre essas pioneiras.
          </p>
          <p>
            <strong>Você ainda pode ganhar um prêmio incrível!</strong>
          </p>
          <Button
            onClick={() => handleOpenGame()}
            className="text-lg p-6 uppercase"
          >
            Participar do Quiz
          </Button>
        </div>
        <div
          className="pt-10 pb-5 bg-no-repeat bg-right bg-contain"
          style={{
            backgroundImage: `url(${bgScroller})`,
          }}
        >
          <h3 className="inline-block text-xl font-bold py-3 px-8 pl-20 bg-secondary rounded-tr-full rounded-br-full">
            Mulheres inspiradoras da TI
          </h3>
          <div className="mt-8 py-8 w-full overflow-hidden">
            <Swiper
              modules={[FreeMode, Virtual, Autoplay]}
              slidesPerView={"auto"}
              autoplay={{
                delay: 2000,
                pauseOnMouseEnter: true,
              }}
              freeMode
              loop
              speed={1500}
            >
              {Array.from({ length: TOTAL_PICTURES }).map((_, index) => (
                <SwiperSlide
                  key={`a_${index}`}
                  className="w-[200px]"
                  virtualIndex={index}
                >
                  <img
                    key={index}
                    src={`/assets/img/slider/${index}.png`}
                    alt="random"
                    className="w-36 mx-auto"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div
          className="bg-secondary px-20 py-10 bg-right bg-no-repeat bg-contain flex items-center"
          style={{
            backgroundImage: `url(${bgFooter})`,
          }}
        >
          <div className="space-y-6 flex-1">
            <div className="flex gap-5">
              <img src={iconFooterAdesivo} alt="" />
              <img src={iconFooterBB} alt="" />
              <img src={iconFooterGames} alt="" />
              <img src={gamificaBB} alt="" />
            </div>
            <div className="opacity-60">
              <p>https://movimentomulheresnati.labbs.com.br/</p>
            </div>
          </div>
          <div>
            <img src={iconFooterAssinatura} alt="" />
          </div>
        </div>
      </div>
      )}
    </>
  );
}
